
import React, { useState, useEffect } from "react";
import ExpiredSoonModal from "./ExpiredSoonModal"; // your modal component

export function SubscriptionExpiryAlert({ expiryDate }) {
  const subscriptionExpiryDate = expiryDate; // example expiry date
  const [expiredSoonModalVisible, setExpiredSoonModalVisible] = useState(false);

  // Check if subscription expires soon (within 7 days)
  const isExpiringSoon = (date, daysThreshold = 7) => {
    const today = new Date();
    const expiry = new Date(date);
    const diffTime = expiry - today;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= daysThreshold;
  };

  
  useEffect(() => {
    // Function to check and update modal visibility
    const checkExpiry = () => {
      if (isExpiringSoon(subscriptionExpiryDate)) {
        setExpiredSoonModalVisible(true);
      } else {
        setExpiredSoonModalVisible(false);
      }
    };

    // Initial check when component mounts
    checkExpiry();
    const intervalId = setInterval(checkExpiry, 60 * 60 * 1000);
    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, [subscriptionExpiryDate]);

  return (
    <div>
      <ExpiredSoonModal
        expiredSoonModalVisible={expiredSoonModalVisible}
        setExpiredSoonModalVisible={setExpiredSoonModalVisible}
        subscriptionExpiryDate={subscriptionExpiryDate}
      >
      </ExpiredSoonModal>
    </div>
  );
};
